import config from '../../config';

const configAPIGateway = config.configAPIGateway();
const _configAPITecnico = config.configAPITecnico();
const _configAPIBiometria = config.configAPIBiometria();

class AuthService {

  async tokenGateway() {
    try {
      let response = await fetch(`${configAPIGateway.URI_GATEWAY}/token?usuario=${configAPIGateway.API_USER}&senha=${configAPIGateway.API_PASS}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        },
      });

      if (response.status === 200) return await response.json();
      return null;

    } catch (error) {
      console.log(error);
    }
  }

  async login(usuario) {
    try {
      let response = await fetch(`${_configAPITecnico.URI_API}/usuario/login`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: usuario
      });

      if (response.status === 200) return await response.json();
      return null;

    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Etapa facial do login (quando a API devolve etapaFacial): com o token TEMPORÁRIO, pede ao backend de
   * biometria o link de uso único para o front de biometria. Retorna a URL ou null.
   */
  async iniciarEtapaFacial(tokenTemporario) {
    if (!_configAPIBiometria.URI_API) return null;
    try {
      const response = await fetch(`${_configAPIBiometria.URI_API}/api/portal/access`, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${tokenTemporario}` }
      });
      if (response.status !== 200) return null;
      const body = await response.json();
      return body.redirectUrl || null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  /**
   * Conclui o login após a etapa facial: token temporário + comprovante de uso único. A API resgata o
   * comprovante e devolve a sessão completa ({ usuario, token }), igual ao login por senha.
   */
  async loginFacial(tokenTemporario, codigo) {
    try {
      const response = await fetch(`${_configAPITecnico.URI_API}/usuario/login/facial`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenTemporario}`
        },
        body: JSON.stringify({ codigo })
      });
      if (response.status === 200) return await response.json();
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  logOut() {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('firstLoginUser');
    localStorage.removeItem('loginTime');
    return null;
  }

  getUserInfo() {
    return JSON.parse(localStorage.getItem('userInfo'));
  }

  async request(url, options = {}) {
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      if (response.status === 401 || response.status === 404) {
        this.handleAuthError();
        throw new Error(`Erro ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      console.error('Erro na requisição:', error);
      if (error.message === 'Erro 401' || error.message === 'Erro 404') {
        this.handleAuthError();
      }
      throw error;
    }
  }
  
  getToken() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    return userInfo ? userInfo.token : null;
  }

  handleAuthError() {
    this.logOut();
    window.dispatchEvent(new CustomEvent('openLoginModal'));
  }

  headerAPITecnico() {
    if (!localStorage.getItem('userInfo'))
      return {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };

    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${JSON.parse(localStorage.getItem('userInfo')).token}`
    };
  }
}

export default new AuthService();
